import Choices from 'choices.js';
import { ResizeHandler } from '../../utilities/js/resize-handler';

const CLASS_IS_VISIBLE = 'is--visible';
const CLASS_ROW_COMPARED = 'row--compared';
const CLASS_IS_ORIGINAL = 'is--original';
const ACTIONS_ROW = document.querySelectorAll('.material-color__actions .row')[0];
const COLOR_GROUP = document.querySelectorAll('.material-color__group')[0];
const COLOR_ITEM = document.querySelectorAll('.material-color__color')[0];
const COLOR_ROW = document.querySelectorAll('.row--item')[0];
const COLOR_ITEM_ROW = document.querySelectorAll('.item-color-row')[0];
const OVERLAY_CLOSE = document.querySelectorAll('[data-overlay="close"]')[0];

class MaterialCompare {
    constructor ($materialCompare) {
        this.$materialCompare = $materialCompare;
        this.$materialImage = document.querySelectorAll('.material-color__item')[0];
        this.compareViewIsVisible = false;
        this.materialSelect = document.querySelectorAll('#materialgroup-switch')[0];
        this.materialColorSelect = document.querySelectorAll('#materialgroup-color-switch')[0];
        const WINDOW_LOCATION = window.location;
        const BASE_URL = WINDOW_LOCATION.protocol + '//' + WINDOW_LOCATION.host + '/' + WINDOW_LOCATION.pathname.split('/')[1];
        this.requestUrl = `${BASE_URL}/material-group-overlay/`;
        this.requestZoomshotUrl = `${BASE_URL}/material-color/`;
        this.viewWidth = new ResizeHandler();
    }

    initialize () {
        this.bindEvents();
        this.initSelectFields();
    }

    bindEvents () {
        if (this.$materialCompare) {
            this.$materialCompare.addEventListener('click', () => {
                this.toggleCompareView();
                this.toggleCompareLabel();
                this.enableTabletSelectField();
            });

            window.addEventListener('resize', () => {
                this.enableTabletSelectField();
            });

            this.materialSelect.onchange = (e) => {
                this.updateChoices(e.target.value);
            };

            this.materialColorSelect.onchange = (e) => {
                this.getComparableImageFromResponse(e.target.value);
            };
        }
    }

    enableTabletSelectField () {
        if (this.compareViewIsVisible) {
            if ((window.innerWidth <= this.viewWidth.specialEvents.sizeDesktop.min) && (window.innerWidth >= this.viewWidth.specialEvents.sizeTablet.min)) {
                COLOR_ITEM_ROW.appendChild(COLOR_GROUP);
                COLOR_ITEM_ROW.appendChild(COLOR_ITEM);
                COLOR_ITEM_ROW.classList.add(CLASS_ROW_COMPARED);
            } else {
                COLOR_ITEM_ROW.classList.remove(CLASS_ROW_COMPARED);
                ACTIONS_ROW.insertBefore(COLOR_GROUP, OVERLAY_CLOSE);
                ACTIONS_ROW.insertBefore(COLOR_ITEM, OVERLAY_CLOSE);
            }
        }
    }

    toggleCompareView () {
        if (!this.compareViewIsVisible) {
            ACTIONS_ROW.classList.add(CLASS_ROW_COMPARED);
            COLOR_GROUP.classList.add(CLASS_IS_VISIBLE);
            COLOR_ITEM.classList.add(CLASS_IS_VISIBLE);
            COLOR_ROW.classList.add(CLASS_ROW_COMPARED);
            this.$materialImage.classList.add(CLASS_IS_ORIGINAL);
            this.getComparableColorsForSelect();
            this.compareViewIsVisible = true;
        } else {
            ACTIONS_ROW.classList.remove(CLASS_ROW_COMPARED);
            COLOR_ROW.classList.remove(CLASS_ROW_COMPARED);
            COLOR_GROUP.classList.remove(CLASS_IS_VISIBLE);
            COLOR_ITEM.classList.remove(CLASS_IS_VISIBLE);
            COLOR_ITEM_ROW.classList.remove(CLASS_ROW_COMPARED);
            this.$materialImage.classList.remove(CLASS_IS_ORIGINAL);
            this.removeComparableImage();
            this.compareViewIsVisible = false;
        }
    }

    toggleCompareLabel () {
        const me = this.$materialCompare;
        me.innerHTML = this.compareViewIsVisible ? me.getAttribute('data-label-stop-compare') : me.getAttribute('data-label-start-compare');
    }

    removeComparableImage () {
        this.$imageWrapper.parentNode.removeChild(this.$imageWrapper);
        this.$imageWrapper = null;
    }

    createComparableImage () {
        if (this.$imageWrapper) {
            this.removeComparableImage();
        }

        this.$imageWrapper = document.createElement('div');
        const me = this.$imageWrapper;
        const materialImage = this.$materialImage;

        me.classList.add('material-color__item', 'is--compared');

        materialImage.parentNode.appendChild(me);
    }

    getComparableColorsForSelect () {
        fetch(this.requestUrl + this.materialSelect.value).then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                return Promise.reject(response);
            }
        }).then((data) => {
            this.setComparableColorsForSelect(data);
            this.getComparableImageFromResponse(data.materialColors[0].value);
        }).catch((err) => {
            console.warn('Something went wrong while getting Colors Content: ', err);
        });
    }

    initSelectFields () {
        this.materialChoices = new Choices(this.materialSelect, {
            searchEnabled: false,
            itemSelectText: '',
            shouldSort: false
        });
    }

    setComparableColorsForSelect (data) {
        if (!this.choices) {
            this.choices = new Choices(this.materialColorSelect, {
                searchEnabled: false,
                itemSelectText: '',
                shouldSort: false
            });

            data.materialColors[0].selected = true;

            this.choices.setChoices(data.materialColors);
        }
    }

    updateChoices (item) {
        fetch(this.requestUrl + item).then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                return Promise.reject(response);
            }
        }).then((data) => {
            this.choices.clearChoices();
            data.materialColors[0].selected = true;

            this.choices.setChoices(data.materialColors);
            this.getComparableImageFromResponse(data.materialColors[0].value);
        }).catch((err) => {
            console.warn('Something went wrong while getting Colors Content: ', err);
        });
    }

    getComparableImageFromResponse (color) {
        fetch(this.requestZoomshotUrl + color).then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                return Promise.reject(response);
            }
        }).then((data) => {
            this.createComparableImage();
            this.setComparableImageToOverlay(data);
        }).catch((err) => {
            console.warn('Something went wrong while getting Material Content: ', err);
        });
    }

    setComparableImageToOverlay (data) {
        this.$imageWrapper.innerHTML = data.zoomShot;
    }
}

export { MaterialCompare };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-material-compare="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new MaterialCompare($root);
            $rootAPI.initialize();
        });
    }
});
